var map = {
	"./acre-of-farmland.jpeg": 7877,
	"./air-jordans.jpeg": 7113,
	"./airpods.jpeg": 8635,
	"./amazon-echo.jpeg": 1231,
	"./apache-helicopter.jpeg": 5197,
	"./auto-rickshaw.jpeg": 5375,
	"./big-mac.jpeg": 3143,
	"./bike.jpeg": 7605,
	"./billgates.jpeg": 4185,
	"./boeing-747.jpeg": 2640,
	"./book.jpeg": 2581,
	"./coca-cola-pack.jpeg": 4235,
	"./cruise-ship.jpeg": 9206,
	"./designer-handbag.jpeg": 8881,
	"./diamond-ring.jpeg": 354,
	"./drone.jpeg": 7341,
	"./ferrari.jpeg": 7676,
	"./flip-flops.jpeg": 4503,
	"./ford-f-150.jpeg": 8028,
	"./formula-1-car.jpeg": 9287,
	"./gaming-console.jpeg": 1156,
	"./gold-bar.jpeg": 4924,
	"./horse.jpeg": 1743,
	"./hot-tub.jpeg": 8783,
	"./jet-ski.jpeg": 4009,
	"./kitten.jpeg": 3514,
	"./lobster-dinner.jpeg": 4820,
	"./luxury-wine.jpeg": 3327,
	"./m1-abrams.jpeg": 2855,
	"./make-a-movie.jpeg": 857,
	"./mansion.jpeg": 7554,
	"./mcdonalds-franchise.jpeg": 4083,
	"./mona-lisa.jpeg": 606,
	"./monster-truck.jpeg": 7742,
	"./movie-ticket.jpeg": 422,
	"./nba-team.jpeg": 3374,
	"./puppy.jpeg": 2497,
	"./rolex.jpeg": 1326,
	"./single-family-home.jpeg": 1425,
	"./skyscraper.jpeg": 3988,
	"./smartphone.jpeg": 4906,
	"./superbowl-ad.jpeg": 5639,
	"./tesla.jpeg": 4561,
	"./video-game.jpeg": 4890,
	"./yacht.jpeg": 1060,
	"./year-of-netflix.jpeg": 732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2941;